// input validation

// usa zip
export const isValidUSZipCode = (zipCode) => {
  const zipCodeRegEx = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
  return zipCodeRegEx.test(zipCode);
};
export const validateUSZipCode = (value) => {
  if (!isValidUSZipCode(value)) return ' ';
  return null;
};

// canada zip
// [A-Za-z][0-9][A-Za-z] [0-9][A-Za-z][0-9] 
// ^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$
// /^(?:[ABCEGHJ-NPRSTVXY]\d[A-Z][ -]?\d[A-Z]\d)$/i
export const isValidCAZipCode = (zipCode) => {
  const zipCodeRegEx = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/;
  return zipCodeRegEx.test(zipCode);
};
export const validateCAZipCode = (value) => {
  if (!isValidCAZipCode(value)) return ' ';
  return null;
};

export const isValidEmail = (email) => {
  const emailRegEx = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
  return emailRegEx.test(email);
};

export const validateEmail = (value) => {
  if (!isValidEmail(value)) return ' ';
  return null;
};

export const isValidPhoneNumber = (phoneNumber) => {
  // const phoneNumberRegEx = /^[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-/\s.]?[0-9]{4}$/;
  const phoneNumberRegEx = /^\d{10}$/;
  return phoneNumberRegEx.test(phoneNumber);
};

export const validatePhoneNumber = (value) => {
  if (!isValidPhoneNumber(value)) return ' ';
  return null;
};



//////////////////
// WEBPACK FOOTER
// ./config/validation.js
// module id = null
// module chunks = 